module.exports = __webpack_public_path__ + "static/waves-19c098872e5c221afdfad105c3ccb9fb.png";